import React, { Fragment, useEffect, useState } from "react";
import "./styles.css";
import { RootState } from "common/rootReducer";
import { OrderItem, OrderItemOption } from "common/features/order/orderModels";
import PriceText from "components/priceText";
import ItemCountSpinner from "components/InputComponents/ItemCountSpinner";
import { useDispatch, useSelector } from "react-redux";
import { CartItem } from "common/features/cart/cartModels";
import { ReactComponent as ArrowIcon } from "common/assets/svg/leftArrow.svg";
import CustomisationPrompt from "components/prompts/desktopCustomisation";

import {
  decrementCartItem,
  incrementCartItem,
  removeCartItem,
  showItemMaxCountPrompt,
  startItemCustomisation,
  updateCartItem,
} from "common/features/cart/cartActions";
function CartItemCard(props: any) {
  const cartItem = props.cartItem as CartItem;  
  const [showCartItemDetailsIndex, setShowCartItemDetailsIndex] = useState<
    number[]
  >([]);
  const individualCustomisedItems = useSelector(
    (state: RootState) => state.cart.customisedIndividualItems
  );

  const totalItemcount = useSelector((state: RootState) =>
    state.cart.cart.items.reduce(
      (accumulator: number, currentValue: CartItem) => {
        return accumulator + +currentValue.quantity;
      },
      0
    )
  );

  const toggleShowCartItemDetails = (index: number) => {
    if (showCartItemDetailsIndex.includes(index)) {
      showCartItemDetailsIndex.splice(
        showCartItemDetailsIndex.indexOf(index),
        1
      );
    } else {
      showCartItemDetailsIndex.push(index);
    }
    setShowCartItemDetailsIndex([...showCartItemDetailsIndex]);
  };

  const customisationSavedItems = useSelector(
    (state: RootState) => state.cart.customisationSavedItems
  );
  const dispatch = useDispatch();

  const itemIndividualCustomisationEnabled =
    individualCustomisedItems?.includes(cartItem.itemId);

  const isCustomizable = cartItem?.options?.length > 0;
  const isItemCustomisable = customisationSavedItems.includes(cartItem.itemId) && isCustomizable;

  const index = props.index;

  const [openCustomisation, setOpenCustomisation] = useState(false);
  const [customisationItemId, setCustomisationItemId] = useState("");

  return (
    <div>
      <div className="desktop-home-cart-item-detail">
        {(cartItem.options.length > 0 || cartItem.comment?.length > 0) && (
          <div
            className="desktop-home-cart-item-detail-col-toggler"
            onClick={() => toggleShowCartItemDetails(index)}
          >
            <ArrowIcon
              className={
                showCartItemDetailsIndex.includes(index)
                  ? "desktop-open-icon desktop-open-icon-selected"
                  : "desktop-open-icon"
              }
            />
          </div>
        )}
        <div className="desktop-home-cart-item-name-container">
          <div className="cart-item-detail-col-name">
            <span>{cartItem.itemName}</span>
          </div>
          <div className="cart-item-detail-col-name">
            <span>{cartItem.itemAltName}</span>
          </div>
        </div>

        <div className="desktop-home-cart-item-detail-col-spinner">
          <ItemCountSpinner
            size="medium"
            count={parseInt(cartItem.quantity)}
            decrementDisabled={false}
            onPressDecrement={() => {
              if (itemIndividualCustomisationEnabled) {
                if (+cartItem.quantity == 1) {
                  dispatch(removeCartItem(cartItem.itemId, index));
                } else if (+cartItem.quantity > 1) {
                  dispatch(decrementCartItem(cartItem.itemId, index));
                }
              } else {
                // console.log(
                //   `decrement ${cartItem.quantity} ${cartItem.itemId} index: ${index}`
                // );
                // All Items are Removed from Cart - Reroute to Menu Page
                if (+cartItem.quantity == 1) {
                  dispatch(removeCartItem(cartItem.itemId, index));
                  // if (totalItemcount === 1) {
                  //   // Move to Restaurant Menu Page
                  //   if (isContactlessDineInOrder) {
                  //     paramsData.tableId &&
                  //       history.push(
                  //         getRestaurantMenuURLWithTableID(
                  //           "restaurant",
                  //           restaurantSlug,
                  //           paramsData.tableId,
                  //           menuType
                  //         )
                  //       );
                  //   } else {
                  //     history.push({
                  //       pathname: getMerchantMenuURL(
                  //         restaurantSlug,
                  //         menuType
                  //       ),
                  //       state: {
                  //         loadMenuRequired: false,
                  //       } as MenuRouteState,
                  //     });
                  //   }
                  // }
                } else {
                  dispatch(decrementCartItem(cartItem.itemId, index));
                }
              }
            }}
            onPressIncrement={() => {  
              if (isItemCustomisable) {
              //   customizeItem()
              // Open Modal for Repeat / New Customizations
              // setCurrentCartItem(cartItem);
              // setCurrentItemIndex(index);
              // setPopup(true);
              dispatch(startItemCustomisation([cartItem]));
              dispatch(
                updateCartItem(
                  cartItem?.itemId,
                  cartItem?.offerPrice ? String(cartItem?.offerPrice) : cartItem?.price,
                  false,
                  Number(cartItem?.quantity)
                )
              );
              props?.setCustomisationItemId(cartItem.itemId)
              props?.setOpenCustomisation(true)
              } else {
             // if (+cartItem.quantity < Number(cartItem.stockQuantity)) {
                dispatch(incrementCartItem(cartItem.itemId, index));
                //dispatch(showItemMaxCountPrompt());
             // } 
              //else {
                // dispatch(incrementCartItem(cartItem.itemId, index));
              //}
              }

              // if (itemIndividualCustomisationEnabled) {
              //   // Open Modal for Repeat / New Customizations
              //   setCurrentCartItem(cartItem);
              //   setCurrentItemIndex(index);
              //   setPopup(true);
              // } else {
              //   // Increment Quantity of Customised Item
              //   if (+cartItem.quantity == 10) {
              //     dispatch(showItemMaxCountPrompt());
              //   } else {
              //     dispatch(incrementCartItem(cartItem.itemId, index));
              //   }
              // }
            }}
          />
        </div>
        <div className="desktop-home-cart-item-detail-col-price">
        <PriceText 
          price={parseFloat(
            cartItem.offerPrice ? String(cartItem.offerPrice) : cartItem.subTotal
          ).toFixed(2)} 
          isMenu={true} 
        />
        </div>
      </div>
      {showCartItemDetailsIndex.includes(index) ? (
        <div className="cart-item-customisers">
          <Fragment>
            {cartItem.options.map((option: OrderItemOption) => {
              return <span>{option.optionName}</span>;
            })}
            <span className="comment">{cartItem.comment}</span>
          </Fragment>
        </div>
      ) : null}
      <CustomisationPrompt
        isOpen={openCustomisation}
        onClose={() => {
          setCustomisationItemId("");
          setOpenCustomisation(false);
        }}
        itemId={cartItem.itemId}
        setOpenCustomisation={setOpenCustomisation}
      />
    </div>
  );
}

export default CartItemCard;
